import { getCurrentAssetSource } from '@/assetSource'

/**
 * Fixed badge shown whenever the assetSource preview cookie is active, so a
 * reviewer can always tell they're not looking at real production assets.
 * Exit navigates with ?assetSource=production — the CloudFront function
 * clears the cookie and redirects back.
 */
export function PreviewBadge() {
  const source = getCurrentAssetSource()

  if (!source) return null

  return (
    <div className="fixed bottom-2 left-2 z-[9999] flex items-center gap-2 rounded-md bg-zinc-900/90 px-3 py-1.5 font-mono text-xs text-white shadow-lg">
      <span>
        previewing <strong>{source}</strong>
      </span>
      <a
        href={`${window.location.pathname}?assetSource=production`}
        className="rounded bg-zinc-700 px-2 py-0.5 hover:bg-zinc-600"
      >
        Exit
      </a>
    </div>
  )
}
